import React, {useState} from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { PEPRequests } from './PEP/PEPRequests';
import { PEPContainer, TabWrapper, Header } from './PEP/PEPRequests.style';
import { PEPState } from 'src/components/FraudAndCompliance/PEPTab/PEPState';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const PEPTab = observer('PEPTab', () => {
    const {trpcClient} = useAppStateContext();
    const [state] = useState(new PEPState(trpcClient));

    return (
        <>
            <PEPContainer>
                <Header>PEP & Sanctions</Header>

                <TabWrapper>
                    <Loader isActive={state.isLoading}/>

                    <PEPRequests
                        PEPState={state}
                    />
                </TabWrapper>
            </PEPContainer>
        </>
    );
});
